import { useMember } from "@/contexts/memberContext";
import { resolveDestination } from "@/lib/linkResolver";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";

const LinkInterceptor: React.FC = () => {
  const { "*": path } = useParams();
  const navigate = useNavigate();
  const { member } = useMember();

  useEffect(() => {
    if (!path || !member) return;

    const role = Array.isArray(member.role) ? member.role[0] : member.role;
    const destination = resolveDestination(path, role as string);
    navigate(destination, { replace: true });
  }, [path, member, navigate]);

  return (
    <div className="h-screen v-screen">
      <span className="">Redirecting...</span>
    </div>
  );
};

export default LinkInterceptor;
